/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RolloutTaskNotificationPhase } from './rolloutTaskNotificationPhase';
import { MessageDeliveryError } from './messageDeliveryError';
import { MessageStateEnum } from './messageStateEnum';


export interface RolloutNotificationDetails { 
    /**
     * Created user email ID.
     */
    created_by?: string;
    /**
     * Created Date Time
     */
    created_ts?: Date;
    /**
     * Updated user email ID.
     */
    updated_by?: string;
    /**
     * Updated Date Time
     */
    updated_ts?: Date;
    /**
     * Name of the notification.
     */
    notification_name?: string;
    phase?: RolloutTaskNotificationPhase;
    /**
     * Unique identifier of the notification.
     */
    notification_id?: string;
    notification_delivery_state?: MessageStateEnum;
    /**
     * Date and time when the notification was created.
     */
    notification_created_date?: Date;
    /**
     * Date and time when the notification was last updated.
     */
    notification_updated_date?: Date;
    /**
     * List of delivery issues encountered.
     */
    notification_delivery_issues?: Array<MessageDeliveryError>;
    /**
     * Number of retry attempts made.
     */
    notification_delivery_retry_attempts?: number;
    /**
     * Number of status check attempts made.
     */
    notification_delivery_status_check_attempts?: number;
}
export namespace RolloutNotificationDetails {
}


